<template>
  <div class="content-body">
    <div class="top-content" v-show="curentComponents === 'PlanView' || curentComponents === 'GroupView' || curentComponents === 'AdvView'">
      <div class="top-item">
        <div class="icon"><i class="fa fa-calendar" aria-hidden="true" style="color: #67BBE2;"></i></div>
        <div class="right-content">
          <div class="title">推广计划</div>
          <div class="title-s">投放中：{{ count_data.plan_tfz }}</div>
          <div class="title-s">未投放：{{ count_data.plan_wtf }}</div>
          <div class="title-s">最晚结束投放时间：{{ count_data.plan_time }}</div>
        </div>
      </div>
      <div class="top-item">
        <div class="icon"><i class="fa fa-bullhorn" aria-hidden="true" style="color: #FAB296;"></i></div>
        <div class="right-content">
          <div class="title">推广单元</div>
          <div class="title-s">投放中：{{ count_data.adv_qd }}</div>
          <div class="title-s">未投放：{{ count_data.adv_jy }}</div>
          <!-- <div class="title-s">累计参与投放次数：0</div> -->
        </div>
      </div>
      <div class="top-item">
        <div class="icon"><i class="fa fa-graduation-cap" aria-hidden="true" style="color: #79BBFF;"></i></div>
        <div class="right-content">
          <div class="title">创意组</div>
          <div class="title-s">网页类：{{ count_data.group_web }}</div>
          <div class="title-s">安卓下载类：{{ count_data.group_android }}</div>
          <div class="title-s">苹果下载类：{{ count_data.group_ios }}</div>
        </div>
      </div>
      <div class="top-item" style="border-right: none;">
        <div class="icon"><i class="fa fa-list-ol" aria-hidden="true" style="color: #EDBE78;"></i></div>
        <div class="right-content">
          <div class="title">广告创意</div>
          <div class="title-s">审核中：{{ count_data.adv_shz }}</div>
          <div class="title-s">审核通过：{{ count_data.adv_shtg }}</div>
          <div class="title-s">审核失败：{{ count_data.adv_shsb }}</div>
        </div>
      </div>
    </div>
    <div class="message" v-show="curentComponents === 'PlanView' || curentComponents === 'GroupView' || curentComponents === 'AdvView'">
      <div class="msg">
        <div><span>·</span>推广单元必须加入推广计划中方可投放;否则无法单独投放﹔</div>
        <div><span>·</span>广告是否投放以推广计划为准，单个推广计划中可以包含多个推广单元，单个推广单元划也可以在多个推广计划中投放;</div>
        <div><span>·</span>当推广单元不在任何推广计划中时，该推广单元则不会进行投放;</div>
      </div>
    </div>
    <component :is="curentComponents"
    :plan_data="plan_data"
    :group_data="group_data"
    :adv_data="adv_data"
     @showOther="showOther"
     @plan_call_back="plan_call_back"
     @jump_form_plan="jump_form_plan"
     @jump_form_group="jump_form_group"
     @jump_form_adv="jump_form_adv"
     ></component>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  /* global require */
  name: 'index',
  data() {
    return {
      curentComponents: 'PlanView',
      plan_data: [], // 修改数据时数据
      group_data: [], // 修改数据时数据
      adv_data: [], // 修改数据时数据
      count_data: {
        plan_tfz: 0,
        plan_wtf: 0,
        plan_time: '-',
        group_web: 0,
        group_ios: 0,
        group_android: 0,
        adv_shz: 0,
        adv_shsb: 0,
        adv_shtg: 0,
        adv_qd: 0,
        adv_jy: 0
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$http.post('/trader/index/getPlanCount').then(res => {
        if (res.code === 200) {
          this.count_data = res.data;
        }
      });
    },
    showOther(type) {
      const views = {
        plan: 'PlanView',
        group: 'GroupView',
        adv: 'AdvView'
      };
      if (type !== '') {
        this.curentComponents = views[type];
      }
    },
    plan_call_back(type) {
      const views = {
        cancel: 'PlanView',
        next: 'CreateGroup',
        groupCancel: 'GroupView',
        groupNext: 'CreateAdv',
        advCancel: 'AdvView'
      };
      if (type !== '') {
        this.curentComponents = views[type];
      }
    },
    jump_form_plan(plan_data = []) {
      this.curentComponents = 'CreatePlan';
      this.plan_data = plan_data;
    },
    jump_form_group(group_data = []) {
      this.curentComponents = 'CreateGroup';
      this.group_data = group_data;
    },
    jump_form_adv(adv_data = []) {
      this.curentComponents = 'CreateAdv';
      this.adv_data = adv_data;
    }
  },
  components: {
    PlanView: resolve => require(['./Components/Plan.vue'], resolve),
    GroupView: resolve => require(['./Components/Group.vue'], resolve),
    AdvView: resolve => require(['./Components/Adv.vue'], resolve),
    CreatePlan: resolve => require(['./Components/create_plan.vue'], resolve),
    CreateGroup: resolve => require(['./Components/create_group.vue'], resolve),
    CreateAdv: resolve => require(['./Components/create_adv.vue'], resolve)
  }
};
</script>
<style lang="less" scoped="">
  .top-content {
    background: #fff;
    margin-bottom: 16px;
    padding-top: 16px;
    display: flex;
    .top-item {
      display: flex;
      width: 25%;
      height: 140px;
      border-right: 1px solid #EFEFEF;
      .icon, .right-content {
        height: 100%;
      }
      .icon {
        width: 35%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
      .right-content {
        margin-left: 25px;
        .title {
          font-size: 20px;
          font-weight: 700;
          color: #666666;
          margin: 20px 0 6px;
        }
        .title-s {
          font-size: 14px;
          color: #9FA2B2;
        }
      }
      i {
        font-size: 60px;
      }
    }
  }
  .message {
    width: calc(100% - 32px);
    background: #fff;
    padding: 16px;
    padding-bottom: 0px;
    .msg {
      width: calc(100% - 30px);
      background: #E6F9FC;
      border: 1px solid #00C1DE;
      padding: 20px 15px;
      color: #99999F;
      font-size: 14px;
      span {
        font-size: 36px;
        margin-right: 5px;
      }
      div {
        height: 26px;
        display: flex;
        align-items: center;
      }
    }
  }
</style>
